import { BackButton, Header, Loader } from "@egovernments/digit-ui-react-components";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { convertEpochToDateDMY } from "../../../utils";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Popover, TextField, Typography } from "@mui/material";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import useDepartmentSelector from "../../citizen/TCPForms/hooks/useDepartmentSelector";
import Summary from "../TCPForms/formComponents/purchasableFAR/Summary";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { ArrowDownward } from "@mui/icons-material";
import FilterListIcon from "@mui/icons-material/FilterList";

const PurchasableFarApplications = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowLandUseNOC, setSmShowLandUseNOC] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [itemData, setItemData] = useState({});
  const [SmShowFAR, setSmShowFAR] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderBy, setOrderBy] = useState("applicationDate"); // Initial sorting column
  const [order, setOrder] = useState("desc"); // Initial sorting order ('asc' or 'desc')
  const [selectedColumns, setSelectedColumns] = useState([
    "srNo",
    "name",
    "mobileNumber",
    "applicationNo",
    "applicationType",
    "applicationDate",
    "status",
  ]);
  // const [rowsPerPageOptions, setRowsPerPageOptions] = useState([5, 10, 20,]);
  const limit = rowsPerPage;
  const [currentpage, setCurentPage] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const departement = applicationFlow;
  console.log("tenantId", tenantId, departement, rowsPerPage);
  let type = "PURCHASABLE_FAR";
  const { data = {}, isLoading: loader, refetch } = Digit.Hooks.obps.useBPADetailsPage(
    tenantId,
    {
      applicationType: "FORM_PURCHASABLE_FAR",
      pageNumber: currentpage + 1, // Backend APIs are often 1-indexed
      pageSize: rowsPerPage,
    },
    { formType: type }
  );
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: "",
  });
  // setRowsPerPageOptions([5, 10, 20, data?.Count]);
  console.log("dataApplications", data);
  React.useEffect(() => {
    refetch(); // Fetch data when page or limit changes
  }, [currentpage, rowsPerPage, refetch]);
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleObjectionLetter = (item) => {
    console.log("itemfromFunctionLetter", item);

    const objectionKey = Object.keys(item?.objectionLetterUrl).find((key) => key.startsWith("objection_"));
    const objectionLetterUrl = item?.objectionLetterUrl[objectionKey];
    window.open(objectionLetterUrl, "_blank");
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = data?.PurchasableFAR || [];

    // Apply global search first
    if (globalSearch) {
      filteredData = filteredData?.filter((item) => {
        return (
          matchesSearch(item?.landInfo?.owners?.[0]?.name, globalSearch) ||
          // matchesSearch(item?.plotArea, globalSearch) ||
          matchesSearch(item?.landInfo?.owners?.[0]?.mobileNumber, globalSearch) ||
          matchesSearch(item?.applicationNo, globalSearch) ||
          matchesSearch(item?.applicationType, globalSearch) ||
          matchesSearch(item?.status, globalSearch)
          // matchesSearch(item?.schemeName, globalSearch) ||
          // matchesSearch(convertEpochToDateDMY(item?.auditDetails?.createdTime), globalSearch)
        );
      });
    }

    // Apply column filters
    if (filters.name) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.landInfo?.owners?.[0]?.name, filters.name));
    }

    if (filters.architect) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.professionaldetails?.name, filters.architect));
    }

    if (filters.plotArea) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.plotArea?.toString(), filters.plotArea));
    }

    if (filters.mobileNumber) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.landInfo?.owners?.[0]?.mobileNumber, filters.mobileNumber));
    }

    if (filters.applicationNo) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.applicationNo, filters.applicationNo));
    }

    if (filters.applicationType) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.applicationType, filters.applicationType));
    }

    if (filters.schemeName) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.schemeName, filters.schemeName));
    }

    if (filters.status) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.status, filters.status));
    }

    return filteredData;
  };
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = (item) => {
        switch (orderBy) {
          case "name":
            return item?.landInfo?.owners?.[0]?.name?.toLowerCase() || "";
          case "mobileNumber":
            return item?.landInfo?.owners?.[0]?.mobileNumber || "";
          case "applicationNo":
            return item?.applicationNo?.toLowerCase() || "";
          case "applicationType":
            return t(item?.applicationType)?.toLowerCase() || "";
          case "status":
            return t(`WF_BPA_MAP_${item?.status}`)?.toLowerCase() || "";
          case "applicationDate":
            return item?.auditDetails?.createdTime || 0;
          default:
            return "";
        }
      };

      const aValue = getValue(a);
      const bValue = getValue(b);

      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const allColumns = [
    {
      id: "srNo",
      label: "Sr No",
      filterable: false,
      width: "5%",
      renderCell: (_item, index, page, rowsPerPage) => <td className="td-srno">{page * rowsPerPage + index + 1}</td>,
    },
    {
      id: "name",
      label: "Name",
      filterable: true,
      sortable: true,
      width: "12%",
      renderCell: (item) => <td className="td-name">{item?.landInfo?.owners?.[0]?.name || "-"}</td>,
    },
    {
      id: "mobileNumber",
      label: "Mobile No.",
      filterable: true,
      sortable: true,
      width: "10%",
      renderCell: (item) => <td className="td-mobile">{item?.landInfo?.owners?.[0]?.mobileNumber || "-"}</td>,
    },
    {
      id: "applicationNo",
      label: "Application No.",
      filterable: true,
      sortable: true,
      width: "10%",
      renderCell: (item) => (
        <td className="td-appno">
          <strong style={{ color: "#007bff", textDecoration: "none", cursor: "pointer" }} onClick={() => handleClickAction(item)}>
            {item?.applicationNo || "-"}
          </strong>
        </td>
      ),
    },
    {
      id: "applicationType",
      label: "Application Type",
      filterable: true,
      sortable: true,
      width: "10%",
      renderCell: (item) => <td className="td-apptype">{t(item?.applicationType) || "-"}</td>,
    },
    {
      id: "applicationDate",
      label: "Date",
      filterable: false,
      sortable: true,
      width: "10%",
      renderCell: (item) => <td className="td-date">{convertEpochToDateDMY(item?.auditDetails?.createdTime) || "-"}</td>,
    },
    {
      id: "status",
      label: "Status",
      filterable: true,
      sortable: true,
      width: "13%",
      renderCell: (item) => <td className="td-status">{t(`WF_BPA_MAP_${item?.status}`) || "-"}</td>,
    },
    {
      id: "objectionLetter",
      label: "Objection Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => {
        console.log("item?.objectionLetterUrl", item);
        return (
          <td className="td-objection">
            {item?.objectionLetterUrl && (
              <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => handleObjectionLetter(item)}>
                <span>View</span>
              </Button>
            )}
          </td>
        );
      },
    },
    {
      id: "action",
      label: "Action",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-action">
          {["INITIATE", "UPLOAD_DOC", "FORWARD_TO_LTP"].includes(item?.status) ? (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="primary"
              onClick={() => {
                window.localStorage.setItem("ApplicationStatus", item?.status);
                history.push({
                  pathname: `/digit-ui/citizen/obps/services/purchasableFAR/${item?.applicationNo}`,
                });
              }}
            >
              <span>Edit</span>
            </Button>
          ) : (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="success"
              onClick={() => {
                window.localStorage.setItem("ApplicationStatus", item?.status);
                history.push({
                  pathname: `/digit-ui/citizen/obps/structural/PURCHASABLE_FAR/${item?.applicationNo}`,
                });
              }}
            >
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
  ];

  const handleSort = (column) => {
    if (orderBy === column) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(column);
      setOrder("asc");
    }
  };
  // const sortedData = data?.PurchasableFAR?.toSorted((a, b) => {
  //   if (order === "asc") {
  //     return a[orderBy] < b[orderBy] ? -1 : 1;
  //   } else {
  //     return b[orderBy] < a[orderBy] ? -1 : 1;
  //   }
  // }).filter((item) => item.applicationType == "FORM_PURCHASABLE_FAR");
  console.log("sortedData", sortedData);
  const handleClickAction = (item) => {
    window.localStorage.setItem("ApplicationStatus", item?.status);
    Digit.SessionStorage.set("OWNER_INFO", item?.landInfo?.owners?.[0]?.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item?.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structural/PURCHASABLE_FAR/${item?.applicationNo}`,
    });
  };
  const closeModal2 = (item) => {
    Digit.SessionStorage.set("FILE_NO", item?.applicationNo);
    Digit.SessionStorage.set("OWNER_INFO", item?.landInfo?.owners?.[0]?.name);
    if (item?.applicationType === "FORM_PURCHASABLE_FAR") {
      setIdData(item?.applicationNo);
      setFormType("formFAR");
      if (item?.applicationNo != null) {
        setSmShowFAR(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("Application Number Null FORM_PURCHASABLE_FAR ");
    }
  };
  const handleGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(0);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value,
    });
    setPage(0);
  };
  const handleOpenLetter = (item) => {
    if (item?.approvalLetterUrl) {
      const approvalLetterUrlLandUse = `${item?.approvalLetterUrl}`;
      window.open(approvalLetterUrlLandUse, "_blank");
    }
  };
  const handleOpenColumnFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      // Don't allow deselecting all columns - at least one must remain
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const columns = allColumns.filter((col) => selectedColumns.includes(col.id));

  // if (applicationFlow === null) {
  //   return <DepartmentSelector />;
  // }
  return (
    <div>
      {loader && <Loader />}
      <div style={{ padding: "0px 4px" }}>
        {/* <div style={{ marginLeft: "8px", fontSize: "24px", padding: "8px", fontWeight: "500" }}>{`${t("BPA_MY_APPLICATIONS")}`}</div> */}
        <BackButton />
        <TableContainer className="citizen-table-container">
          <div>
            <caption className="citizen-table-caption">Purchasable FAR – My Applications</caption>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                className="bg-white"
                onClick={handleOpenColumnFilter}
                size="small"
                sx={{
                  height: "27px",
                  fontSize: "12px",
                  borderColor: "rgb(31, 74, 124)",
                  color: "rgb(31, 74, 124)",
                }}
              >
                {t("FASTPAS.GLOBAL.FILTERS.TEXT")}({selectedColumns.length}/{allColumns.length})
              </Button>
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search here..."
                value={globalSearch}
                onChange={(e) => handleGlobalSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ background: "#1f4a7c", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                    </InputAdornment>
                  ),
                  endAdornment: globalSearch && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => handleGlobalSearch("")}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  padding: "0px",
                  height: "25px", // sets outer height
                  "& .MuiInputBase-root": {
                    height: "27px",
                    padding: "0px",
                    backgroundColor: '#fff'
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgb(31, 74, 124)",
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "0", // top/bottom padding controls the internal height
                    fontSize: "12px",
                  },
                }}
              />
            </div>
          </div>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleCloseColumnFilter}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div className="select-column-popover">
              <Typography variant="subtitle2" gutterBottom>
                Select Columns to Display
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{ padding: "0px" }}
                    checked={selectedColumns.length === allColumns.length}
                    indeterminate={selectedColumns.length > 0 && selectedColumns.length < allColumns.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedColumns(allColumns.map((col) => col.id));
                      } else {
                        // Optionally, keep at least one column selected
                        setSelectedColumns([allColumns[0].id]);
                      }
                    }}
                  />
                }
                sx={{ margin: "0px", fontWeight: "bold" }}
                label="Select All"
              />
              {allColumns.map((column) => (
                <div key={column.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{ padding: "0px" }}
                        checked={selectedColumns.includes(column.id)}
                        onChange={() => handleColumnToggle(column.id)}
                        disabled={column.id === "srNo" && selectedColumns.length === 1}
                      />
                    }
                    sx={{ margin: "0px" }}
                    label={column.label}
                  />
                </div>
              ))}
            </div>
          </Popover>
          <Table stickyHeader aria-label="sticky table" className="citizen-application-table">
            <thead>
              <tr className="citizen-header-row">
                {columns.map((column) => (
                  <td display="flex" alignItems="center">
                    {column.label}
                    {column.sortable && (
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() => handleSort(column.id)}
                        sx={{
                          color: "white !important", // Force white text
                          "& .MuiTableSortLabel-icon": {
                            opacity: "1 !important", // Force icon to always be visible
                            color: "white !important", // Force white icon
                          },
                          "&:hover": {
                            color: "white !important", // Ensure hover doesn't change color
                          },
                        }}
                        // Force the icon to render even when inactive
                        IconComponent={(props) => (
                          <ArrowDownward
                            {...props}
                            sx={{
                              color: "white !important",
                              opacity: 1, // Ensure icon is always visible
                            }}
                          />
                        )}
                      />
                    )}
                  </td>
                ))}
                {/* <td>
                  Status
                  <TableSortLabel
                    active={orderBy === "status"}
                    direction={orderBy === "status" ? order : "asc"}
                    onClick={() => handleSort("status")}
                  />
                </td> */}
                {/* <td>Objection Letter</td> */}
                {/* <td >Approval Letter</td> */}
                {/* <td >View NOC</td> */}
                {/* <td>Summary</td> */}
              </tr>
              <tr>
                {columns?.map((column) => (
                  <td key={column.id}>
                    {column.filterable && (
                      <TextField
                        variant="standard"
                        size="small"
                        value={filters[column.id] || ""}
                        onChange={(e) => handleFilterChange(column.id, e.target.value)}
                        InputProps={{
                          // startAdornment: (
                          //   <InputAdornment position="start">
                          //     <SearchIcon fontSize="small" />
                          //   </InputAdornment>
                          // ),
                          endAdornment: filters[column.id] && (
                            <InputAdornment position="end">
                              <IconButton size="small" onClick={() => handleClearFilter(column.id)} sx={{ color: "white" }}>
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiInput-input": {
                            color: "black !important",
                            fontSize: "0.75rem",
                          },
                          width: "100%",
                        }}
                      />
                    )}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <tr>
                  <td colSpan={columns.length} align="center">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} align="center">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData?.map((item, index) => (
                  <tr key={item.id}>{columns.map((column) => column.renderCell(item, index, page, rowsPerPage))}</tr>
                ))
              )}
            </tbody>
          </Table>
        </TableContainer>
        {/* <TablePagination
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={data?.Count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}
        {/* Pagination controls */}
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 75, 100]}
          component="div"
          count={data?.Count} // Total items count (from your data)
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      <DialogContentModal
        title={"Application Details"}
        dataOpen={SmShowFAR}
        onClose={() => {
          setSmShowFAR(false);
        }}
      >
        <Summary id={idData} />
      </DialogContentModal>
    </div>
  );
};

export default PurchasableFarApplications;
